var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_24083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 0.666687H3C1.346 0.666687 0 2.01269 0 3.66669V6.00002C0 6.73535 0.598 7.33335 1.33333 7.33335H7.33333C8.06867 7.33335 8.66667 6.73535 8.66667 6.00002V2.00002C8.66667 1.26469 8.06867 0.666687 7.33333 0.666687ZM8 6.00002C8 6.36802 7.70067 6.66669 7.33333 6.66669H1.33333C0.966 6.66669 0.666667 6.36802 0.666667 6.00002V3.66669C0.666667 2.38002 1.71333 1.33335 3 1.33335H7.33333C7.70067 1.33335 8 1.63202 8 2.00002V6.00002ZM13 2.00002H11.3333C10.598 2.00002 10 2.59802 10 3.33335V12C10 12.7354 10.598 13.3334 11.3333 13.3334H13C14.654 13.3334 16 11.9874 16 10.3334V5.00002C16 3.34602 14.654 2.00002 13 2.00002ZM15.3333 10.3334C15.3333 11.62 14.2867 12.6667 13 12.6667H11.3333C10.966 12.6667 10.6667 12.368 10.6667 12V3.33335C10.6667 2.96535 10.966 2.66669 11.3333 2.66669H13C14.2867 2.66669 15.3333 3.71335 15.3333 5.00002V10.3334ZM7.33333 8.66669H2.66667C1.93133 8.66669 1.33333 9.26469 1.33333 10V12.3334C1.33333 13.9874 2.67933 15.3334 4.33333 15.3334H7.33333C8.06867 15.3334 8.66667 14.7354 8.66667 14V10C8.66667 9.26469 8.06867 8.66669 7.33333 8.66669ZM8 14C8 14.368 7.70067 14.6667 7.33333 14.6667H4.33333C3.04667 14.6667 2 13.62 2 12.3334V10C2 9.63202 2.29933 9.33335 2.66667 9.33335H7.33333C7.70067 9.33335 8 9.63202 8 10V14Z",
    fill: "#02B9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_24083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLayoutIcon);
export default __webpack_public_path__ + "static/media/dashboardLayoutIcon.036ede0676ba3da2f1f3e745958242d9.svg";
export { ForwardRef as ReactComponent };